<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="900px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>تعریف/ویرایش مجتمع</v-card-subtitle>
        <v-spacer/>
        <v-card-text>


          <v-form ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>
              <v-col cols="12" md="3" sm="12">

                <v-text-field
                    label="نام"
                    outlined
                    dense
                    :error-messages="getError('name')"
                    v-model="model.name"
                />

              </v-col>
              <v-col cols="12" md="3" sm="12">

                <v-text-field
                    label="تعداد واحد"
                    outlined
                    dense
                    type="number"
                    :error-messages="getError('NumberUnit')"
                    v-model="model.numberUnit"
                />

              </v-col>
              <v-col cols="12" md="2" sm="12">
                <v-checkbox
                    label="توکن Bearer "
                    outlined
                    dense
                    v-model="model.isBearer"
                />
              </v-col>
              <v-col v-if="!model.isBearer" cols="12" md="4" sm="12">

                <v-text-field
                    label="شناسه مجتمع(توکن)"
                    outlined
                    dense
                    :error-messages="getError('token')"
                    v-model="model.token"
                />
              </v-col>
              <v-col v-if="model.isBearer" cols="12" md="4" sm="12">

                <v-text-field
                    label="شناسه مجتمع(توکن)"
                    outlined
                    dense
                    :error-messages="getError('token')"
                    v-model="model.tokenBearer"
                />
              </v-col>
              <v-col

                  cols="12" md="4" sm="12"
              >

                <v-text-field
                    label="شناسه مجتمع(پنل)"
                    outlined
                    dense
                    :error-messages="getError('panelId')"
                    v-model="model.panelId"
                />
              </v-col>
              <v-col

                  cols="12" md="4" sm="12"
              >
                <date-picker  placeholder="تاریخ شروع در پنل" v-model="model.startDateTxt" color="#3b5694" clearable
                             auto-submit>
                </date-picker>

              </v-col>
              <v-col cols="12" md="4" sm="12">

                <v-text-field
                    label="شماره شبا"
                    outlined
                    dense
                    :error-messages="getError('iban')"
                    v-model="model.iban"
                />
              </v-col>
              <v-col

                  cols="12" md="4" sm="12"
              >

                <v-text-field
                    label="حداکثر تخفیف"
                    outlined
                    dense
                    :error-messages="getError('maximumAmount')"
                    v-model="model.maximumAmount"
                />
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-switch class="m-0 p-0" dense v-model="model.isSendSms"  label="پیام ارسال شود" color="primary"/>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-switch class="m-0 p-0" dense v-model="model.isActive"  label="مجتمع فعال است" color="primary"/>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-checkbox
                    label="پرداخت آنلاین دارد؟"
                    outlined
                    dense
                    v-model="model.hasOnlinePayment"
                />
              </v-col>
              <v-col cols="12" md="2" sm="12">
                <v-checkbox
                    label=" پارسیان"
                    outlined
                    dense
                    v-model="model.isParsian"
                />
              </v-col>
              <v-col

                  cols="12" md="2" sm="12"
              >

                <v-checkbox
                    label=" صادرات"
                    outlined
                    dense
                    v-model="model.isBsi"
                />
              </v-col>
            </v-row>
            <v-divider class="m-1 p-1"/>
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-text-field
                    outlined
                    dense
                    :error-messages="getError('yearsId')"
                    v-model="yearId" label="شناسه دوره مالی سال"/>
              </v-col>

              <v-col cols="12" md="4" sm="12">
                <v-btn @click="addYearId" block depressed color="success">
                  <v-icon dense>mdi-plus</v-icon>
                  اضافه کردن
                </v-btn>
              </v-col>

            </v-row>
            <v-subheader>شناسه دوره مالی سال:</v-subheader>
            <section class="style-1" style="overflow-y: auto!important;height: 10vh ">
              <v-list>
                <v-list-item v-for="(year,i) in model.yearsId" :key="i">
                  <v-list-item-content>{{ year }}</v-list-item-content>
                  <v-list-item-action>
                    <v-btn depressed class="mr-1" x-small color="error" @click="removeYearId(i)">حذف</v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>

            </section>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="primary"
                  class=" pr-1 pl-1"
                  type="submit"
                  :loading="loading"
              >
                ذخیره
              </v-btn>
              <v-btn
                  small
                  depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Building_se from "@/views/define/building/Building_se";


export default {

  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
  },
  data() {
    return {
      bindingErrors: [],
      loading: false,
      valid: true,
      yearId: '',

    }
  },


  methods: {
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    closed() {
      this.bindingErrors = []
      this.loading = false
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('Building')


    },
    addYearId() {
      this.model.yearsId.push(this.yearId)
      this.yearId=''

    },
    removeYearId(index) {
      this.model.yearsId.splice(index, 1)
    },

    save() {
      // this.loading = true
      this.bindingErrors = []
      this.$progress({message: 'درحال ثبت اطلاعات و واحد ها...'}, true)
      Building_se.save(this.model).then(response => {
        if (response && response.status === 408) {
          this.$root.$emit('Progress')
          this.$snack({type: 'error', message: 'استورم در دسترس نیست!!'})
          this.closed()
        }
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.$snack({type: 'success'})
          this.closed()
        } else if (response && response.response.status === 400) {
          this.loading = false
          this.$root.$emit('Progress')
          this.bindingErrors = response.response.data;
        }
      })

    },

  },


}
</script>
<style>
.style-1::-webkit-scrollbar {
  width: 2px;
  background-color: #F5F5F5;
}

.style-1::-webkit-scrollbar-thumb {
  background-color: #F90;
  background-image: -webkit-linear-gradient(90deg, rgba(255, 255, 255, .2) 25%, orange,
  orange)
}
</style>


